import React, { useState, useEffect } from "react";
import Image from 'next/image'

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
// import "swiper/css";
// import "swiper/css/free-mode"
// import "swiper/css/navigation"
// import "swiper/css/thumbs"

// import Swiper core and required modules
import SwiperCore, {
    FreeMode, Navigation, Thumbs, Pagination, Autoplay
} from 'swiper';

SwiperCore.use([FreeMode, Navigation, Thumbs, Pagination, Autoplay]);

function Productimage({ item }) {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [url_for_360, set_url_for_360] = useState(false);
    const [show_360, set_show_360] = useState(false);
    const [total_images, set_total_images] = useState(4);

    useEffect(() => {
        var count_images = 4
        if (item && item.media && item.media.length >= 4) {
            // we can set to 4 
            count_images = 4
        } else if (item && item.media && item.media.length < 4 && item.variations && item.variations.length > 0) {
            // count each of our variations images  
            var count_images = item.variations.reduce(
                (accumulator, variation) => accumulator + variation.media.length,
                0
            );
            count_images = count_images + item.media.length
        } else {
            count_images = item.media.length
        }
        set_total_images(count_images)
    }, [item])

    useEffect(() => {

        const exists = (item) => {
            var three_sixty_endpoint = '//' + process.env.NEXT_PUBLIC_IMAGE_URL + '/storage/360images/' + item.sku + '/iframe.html'

            var endpoint = process.env.NEXT_PUBLIC_API_URL + '/products-360/' + item.sku
            var headers = {
                'Content-Type': 'application/json'
            }

            fetch(
                endpoint,
                {
                    headers: headers,
                    method: 'GET'
                }
            ).then(response => {
                // reject not ok response
                if (!response.ok) {
                    return Promise.reject(response)
                }
                return response.json() // or return response.text()
            })
                .catch(async response => {
                    const error = await response.json().then(text => text)
                    return Promise.reject(error)
                }).then(data => {
                    // take the original list, and append this info to it
                    // its backwards, as we dont have cors, so if we get a 404, then we use that here
                    if (data.status == true) {
                        set_url_for_360(three_sixty_endpoint)
                    } else {
                        set_url_for_360(false)
                    }
                }).catch((error) => {
                    // and if we get a CORS error, we know there is a resource thats hiding, so use it
                    set_url_for_360(false)
                });
        }
        exists(item)
    }, [item])

    return (
        <div className="w-full lg:w-1/2 flex items-strech">
            <div className="w-full lg:w-4/5 flex items-strech flex-col">

                {(item && item.media && item.media[0] && item.media[0].original_url) ? (
                    <>
                        {/* MAIN IMAGE */}
                        <div className={show_360 ? "hidden w-full product-page-main-image" : "w-full product-page-main-image"}>
                            <Swiper
                                style={{ '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#fff' }}
                                loop={true}
                                pagination={{ type: "fraction" }}
                                spaceBetween={10}
                                navigation={true}
                                grabCursor={true}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: true,
                                }}
                                thumbs={{ swiper: thumbsSwiper }}
                                centeredSlides={true}
                                className="large-swiper bg-white border border-gray-300 mb-2 rounded-lg">
                                {item.media.map((image) => (
                                    (image.collection_name == 'default') ? (
                                        <SwiperSlide key={image.id}>
                                            <Image
                                                src={image.original_url}
                                                alt={item.name}
                                                width={process.env.NEXT_PUBLIC_LARGE_IMAGE_WIDTH}
                                                height={process.env.NEXT_PUBLIC_LARGE_IMAGE_HEIGHT}
                                                className="w-full object-contain"
                                                placeholder="blur"

                                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                            />
                                        </SwiperSlide>
                                    ) : ('')
                                ))}
                                {item.variations.map((variation) => (
                                    variation.media.map((image) => (
                                        (image.collection_name == 'default') ? (
                                            <SwiperSlide key={image.id}>
                                                <Image
                                                    src={image.original_url}
                                                    alt={variation.name}
                                                    width={process.env.NEXT_PUBLIC_LARGE_IMAGE_WIDTH}
                                                    height={process.env.NEXT_PUBLIC_LARGE_IMAGE_HEIGHT}
                                                    className="w-full object-contain"
                                                    placeholder="blur"

                                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                                />
                                            </SwiperSlide>
                                        ) : ('')
                                    ))
                                ))}

                            </Swiper>
                        </div>

                        {/* THUMBNAILS */}
                        <Swiper
                            onSwiper={setThumbsSwiper}
                            loop={total_images > 4 ? true : false}
                            spaceBetween={10}
                            slidesPerView={total_images}
                            grabCursor={true}
                            freeMode={true}
                            watchSlidesProgress={true}
                            className={show_360 ? "hidden w-full product-page-thumbnail-slider" : "w-full product-page-thumbnail-slider"}>

                            {item.media.map((image) => (
                                (image.collection_name == 'default') ? (
                                    <SwiperSlide key={image.id}>
                                        <Image
                                            src={image.original_url}
                                            alt={item.name}
                                            width="150"
                                            height="150"
                                            className="product-page-thumbnail-image"
                                            placeholder="blur"

                                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                        />
                                    </SwiperSlide>
                                ) : ('')
                            ))}
                            {item.variations.map((variation) => (
                                variation.media.map((image) => (
                                    (image.collection_name == 'default') ? (
                                        <SwiperSlide key={image.id}>
                                            <Image
                                                src={image.original_url}
                                                alt={variation.name}
                                                width="150"
                                                height="150"
                                                className="product-page-thumbnail-image"
                                                placeholder="blur"

                                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                            />
                                        </SwiperSlide>
                                    ) : ('')
                                ))
                            ))}
                        </Swiper>

                    </>
                ) : (
                    <>
                        <Image
                            src={process.env.NEXT_PUBLIC_COMING_SOON_IMAGE}
                            alt={item.name}
                            width={process.env.NEXT_PUBLIC_LARGE_IMAGE_WIDTH}
                            height={process.env.NEXT_PUBLIC_LARGE_IMAGE_HEIGHT}
                            className="product-page-thumbnail-image"
                            placeholder="blur"

                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                        />
                    </>
                )}


                {(show_360) ? (
                    <>
                        <div className="aspect-w-4 aspect-h-3 w-full">
                            <iframe src={url_for_360}></iframe>
                        </div>
                    </>
                ) : ('')}


                {/* 360 images from a folder */}
                {(url_for_360) ? (
                    (show_360) ? (
                        <div className="flex justify-center items-center mt-4">
                            <a className="flex justify-center items-center font-semibold"
                                onClick={() => set_show_360(false)}>
                                <i className="icon icon-360-view w-8 h-8 mr-2"></i> Show Images
                            </a>
                        </div>
                    ) : (
                        <div className="flex justify-center items-center mt-4">
                            <a className="flex justify-center items-center font-semibold"
                                onClick={() => set_show_360(true)}>
                                <i className="icon icon-360-view w-8 h-8 mr-2"></i> Get 360° View
                            </a>
                        </div>
                    )

                ) : ('')}


            </div>
        </div>
    );
}

export default Productimage;